import { unescapeHTML } from 'core-js/core/string';

export const getCookieValues = cookieNames => {
  const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
    const [cookieName, cookieValue] = cookie.split('=');
    acc[cookieName] = cookieValue;
    return acc;
  }, {});

  return cookieNames.map(cookieName => cookies[cookieName] || null);
};

export const formatCurrency = (amount, currency = 'USD') => {
  const isWholeNumber = Number.isInteger(amount);

  if (isWholeNumber) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  }

  // For decimal numbers, format with default decimal places
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(amount);
};

export const escapeSpecialChars = (string) => unescapeHTML(string);

export const formatPhoneNumber = (phone) => {
  const plainNumber = phone.replace(/-/g, '');
  const formattedNumber = plainNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');

  return formattedNumber;
};
